<template>
  <div class="dashboard">
    <!--头部信息-->
    <Header />
    <!--进行中-->
    <OnGoing />
    <!--即将开始-->
    <InComing />
    <div class="bottom-logo">
      <!-- <img src="//cdn.hongbaoxd.com/images/dcad39efba024a1eeae3e6336f2863fc.png" alt=""> -->
    </div>
    <QrcodeDialog ref="qrcode" />
    <LinkDialog ref="link" />
  </div>
</template>
<style lang='scss' scoped>
  .dashboard {
    background-color: #3A4E92;
    padding-bottom: 20px;

    .bottom-logo {
      text-align: center;
      height: 18px;

      img {
        height: 18px;
      }
    }
  }
</style>
<script>
import { mapActions } from 'vuex'
import { URI_APPTASK_LIST } from '@/store/modules/dashboard/type'
import Header from './Header'
import OnGoing from './OnGoing'
import InComing from './InComing'
import QrcodeDialog from './popups/QrcodeDialog'
import LinkDialog from './popups/LinkDialog'
import { setUUID, relayPlugInstalls } from '../../assistant/JSBridge'
export default {
  name: 'Dashboard',
  components: {
    Header,
    OnGoing,
    InComing,
    QrcodeDialog,
    LinkDialog
  },
  props: {
    msg: String
  },
  async mounted () {
    let params = this.$route.params
    let url = location.protocol + '//' + location.hostname + '/k1/l/a'

    if (params.status) {
      relayPlugInstalls([], url)
    }

    if (params.uuid) {
      setUUID(params.uuid)
    }

    if (parseInt(params.status) === 1) {
      this.$router.replace('/dashboard')
    }
    await this.getTaskInfo()
  },
  methods: {
    ...mapActions({
      getTaskInfo: URI_APPTASK_LIST
    })
  }
}
</script>
